import sys from '@truckdown/jsclient';
import { defineCustomElement } from 'vue';

//note: this does not generate any css so the layouts do not load any
//if any css is added then the layouts will have to be updated. 

//register app components

import callControl from "./components/CallControl.ce.vue";

sys.configure((app) => {
    app.component('call-control', callControl);
});

const CallControlCustomElement = defineCustomElement(callControl)
if (customElements) {
    customElements.define('call-control', CallControlCustomElement)
}

sys.initialize();
